import { Field, formValueSelector, reduxForm } from 'redux-form';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from 'material-ui/Dialog';
import { UpdateBatchClaimsRenderingProvider } from '../manageClaims/actions/ManageClaimActions';
import { renderAutoCompleteSingleSelect } from '../../../../components/reduxFields';
import { CommonButton } from '../../../../components/buttons';
import SmallLoader from '../../../../img/small-loader.gif';

const validate = (values) => {
  const errors = {};
  if (!values.renderingProvider) {
    errors.renderingProvider = 'Please select rendering provider.';
  }
  return errors;
};

class BatchRenderingProviderModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,      
    };
    this.onSubmitHandler = this.onSubmitHandler.bind(this);
  }

  componentWillReceiveProps(nextProps) {

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }

  handleClose = () => {
    if (this.state.open) {
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  onSubmitHandler(formData) {
    let postData = {
      claimIds: this.props.selectedEDIAndNonEDIClaimIds,   
      renderingProviderId: formData.renderingProvider,
    };
    // console.log(JSON.stringify(postData));
    this.props.UpdateBatchClaimsRenderingProvider(postData.claimIds, postData.renderingProviderId);
    this.handleClose();
  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ?
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
          : null}
      </div>
    );
  }

  render() {
    const { handleSubmit } = this.props;
    const actions = [
      <CommonButton label="Cancel" className="mr-15 grey_btn" onTouchTap={() => this.handleClose()} />,
      <CommonButton type="submit" primary={true} label="Update" onTouchTap={handleSubmit(this.onSubmitHandler)} />,
    ];
    return (
      <Dialog className="custom_modal"
        title={'Batch Update Rendering Provider'}
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}>
        <div className="row">
          <div className="col-sm-12">
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}>
              <div className="row">                
                <div className='col-sm-12 require  mt-35'>
                  <Field
                    name="renderingProvider"
                    label="Rendering Provider"
                    options={this.props.renderingProviderIncludingInactive}
                    handleNewRequest={this.handleNewRequest}
                    component={renderAutoCompleteSingleSelect} />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  };
}

BatchRenderingProviderModal = reduxForm({
  form: 'BatchRenderingProviderModal',
  validate,
  enableReinitialize: true,
})(BatchRenderingProviderModal);

const selector = formValueSelector('BatchRenderingProviderModal');
function mapStateToProps(state) {
  return {
    loading: state.billing.loading,
  };
}

export default connect(mapStateToProps, { UpdateBatchClaimsRenderingProvider })(BatchRenderingProviderModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/BatchRenderingProvider_Modal.js